"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAnonymousUser = void 0;
const consts_1 = require("./consts");
const buildAnonymousUser = (token) => {
    return Object.assign(Object.assign({}, consts_1.anonymousUser), { _id: token, createdAt: new Date() });
};
exports.buildAnonymousUser = buildAnonymousUser;
